import { Tag } from "Components";
import { UserData } from "../CampaignReport.type";
import { RESULT_COLOR } from "../CampaignReport.constant";

const IndividualListItem = ({ userData }: { userData: UserData }) => {
    const { color: resultColor, bg: resultBg } = RESULT_COLOR[userData?.result || ''] || RESULT_COLOR.passed;
    return <div className='list-item'>
        <div className='row'>
            <span className='title'>{userData?.name || ''}</span>
            <Tag className='status-tag' style={{ color: resultColor, background: resultBg }}>
                {userData?.result || ''}
            </Tag>
        </div>
        <div className='row'>
            <span className='description'><strong>Property: </strong>{userData?.propertyName || ''}</span>
            <span className='description'><strong>Group: </strong>{userData?.groupName || ''}</span>
        </div>
        <div className='row'>
            <span className='description'><strong>Source: </strong>{userData?.doneBy || ''}</span>
            <Tag className='status-tag' style={{ color: '#1976D2', background: '#E8F1FB' }}>
                {userData?.interaction || ''}
            </Tag>
        </div>
    </div>
}

export default IndividualListItem;